/**
 * @fileoverview POST handler for the "/app_settings/authentication_credential/create" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appSettingsAuthenticationCredentialCreateCacheKeys } from "./constants";
import type {
  PostAppSettingsAuthenticationCredentialCreateProps,
  AppSettingsAuthenticationCredentialCreateResult,
  AppSettingsAuthenticationCredentialCreateResultErrors,
} from "./types";

export const postAppSettingsAuthenticationCredentialCreate = reactQueryMutationAdapter(
  appSettingsAuthenticationCredentialCreateCacheKeys,
  createMutationFetcherFunctionWithShadowError<AppSettingsAuthenticationCredentialCreateResultErrors>()(
    (
      props: PostAppSettingsAuthenticationCredentialCreateProps
    ): Promise<AppSettingsAuthenticationCredentialCreateResult> => {
      return fetch(
        "/app_settings/authentication_credential/create",
        "POST",
        props,
        {},
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
